import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./admin/context/ToastContext";
import { SessionProvider } from "./context/SessionContext"; // Corrected import
import { CartProvider } from "./context/CartContext";
import AuthGate from "./AuthGate";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";

function App() {
  return (
    // Outermost, so an uncaught render error anywhere shows a recoverable panel
    // instead of React unmounting the tree and leaving a blank white page
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <SessionProvider> {/* SessionProvider wraps everything that needs session data */}
            <ToastProvider>
              <CartProvider>
                <AuthGate />
              </CartProvider>
            </ToastProvider>
          </SessionProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
